import { http } from '..';
import type { CreateProjectDto, Project, ProjectSimplified, Stat, UpdateProjectDto } from './types';

export const fetchAll = async (): Promise<ProjectSimplified[]> => {
  return http.url('/admin/projects').get().json();
};

export const fetchOne = async (id: string): Promise<Project> => {
  return http.url(`/admin/projects/${id}`).get().json();
};

export const update = async (id: string, data: UpdateProjectDto) => {
  return http.url(`/admin/projects/${id}`).put(data).json();
};

export const fetchRequestsStats = async (id: string): Promise<Stat> => {
  return http.url(`/admin/projects/${id}/requests/stats`).get().json();
};

export const create = async (data: CreateProjectDto): Promise<Project> => {
  return http.url('/admin/projects').post(data).json();
};

export const deleteProject = async (id: string) => {
  return http.url('/admin/projects/').delete(id).json();
};

export const fetchProjectsStats = async (id: string): Promise<Stat> => {
  return http.url(`/admin/projects/${id}/stats/summary`).get().json();
};
